'use client';
import {DirectoryCategory} from '@/components/main/directory/DirectoryCategory';
import {AdminCategoryMenu} from '@/components/main/directory/admin/AdminCategoryMenu';
import useDirectoryStore from '@/stores/directory';
import {useEffect} from 'react';

export const Directory = () => {
  const {clearSelectedCategoryInfo} = useDirectoryStore();
  /** 카테고리 칩 선택 상태로 초기화 */
  useEffect(() => {
    clearSelectedCategoryInfo();
  }, []);

  return (
    <>
      {/*  탐색 태그 개선에서 제거하고 연령제한 썸네일 노출 */}
      <AdminCategoryMenu />
      <div id='container' className='_category'>
        <DirectoryCategory />
      </div>
    </>
  );
};
